import { IncentiveOfferType } from 'modules/incentivesMarket/types';

export const addIncentiveOfferLabels: Record<
  IncentiveOfferType,
  Record<string, string>
> = {
  [IncentiveOfferType.SELL]: {
    TITLE: 'IncentivesMarketUnitSaleOffer',
    DESCRIPTION: 'IncentivesMarketUnitSaleOfferDescription',
    BREADCRUMB: 'IncentivesMarketUnitSaleOfferBreadcrumb',
    SELECT_PARTNER: 'IncentivesMarketSelectBeneficiaryWhoSells',
    SELECT_CLASS: 'IncentivesMarketSelectClassToSell',
    SHARES_TO_TRANSFER: 'IncentivesMarketUnitsToSell',
    SHARES_TO_TRANSFER_INFO: 'IncentivesMarketUnitsToSellInfo',
    PRICE: 'IncentivesMarketPriceToSell',
    PRICE_TOTAL: 'IncentivesMarketPriceToSellTotal',
    PRICE_PER_SHARE_INFO: 'IncentiveOfferPriceInfo',
    PRICE_TOTAL_INFO: 'IncentiveOfferTotalPriceInfo',
  },
  [IncentiveOfferType.BUY]: {
    TITLE: 'IncentivesMarketUnitBuyOffer',
    DESCRIPTION: 'IncentivesMarketUnitBuyOfferDescription',
    BREADCRUMB: 'IncentivesMarketUnitBuyOfferBreadcrumb',
    SELECT_PARTNER: 'IncentivesMarketSelectBeneficiaryWhoBuys',
    SELECT_CLASS: 'IncentivesMarketSelectClassToBuy',
    SHARES_TO_TRANSFER: 'IncentivesMarketUnitsToBuy',
    SHARES_TO_TRANSFER_INFO: 'IncentivesMarketUnitsToBuyInfo',
    PRICE: 'IncentivesMarketPriceToBuy',
    PRICE_TOTAL: 'IncentivesMarketPriceToBuyTotal',
    PRICE_PER_SHARE_INFO: 'IncentivesMarketPricePerUnitBuy',
    PRICE_TOTAL_INFO: 'IncentivesMarketPricePerUnitBuy',
  },
};
